import { render, staticRenderFns } from "./WriterTypeIndicatorSkipDialog.vue?vue&type=template&id=59ad363e&scoped=true"
import script from "./WriterTypeIndicatorSkipDialog.vue?vue&type=script&lang=ts"
export * from "./WriterTypeIndicatorSkipDialog.vue?vue&type=script&lang=ts"
import style0 from "./WriterTypeIndicatorSkipDialog.vue?vue&type=style&index=0&id=59ad363e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad363e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ad363e')) {
      api.createRecord('59ad363e', component.options)
    } else {
      api.reload('59ad363e', component.options)
    }
    module.hot.accept("./WriterTypeIndicatorSkipDialog.vue?vue&type=template&id=59ad363e&scoped=true", function () {
      api.rerender('59ad363e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/WriterTypeIndicatorSkipDialog.vue"
export default component.exports